import { useState, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { Button } from "react-bootstrap";
import API_URLS from "../../../../constants/apiConstants";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { LoadingDots } from "../../../../components/general";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AuthContext from "../../../../context/AuthProvider";

export const StaffAllAttendance = ({ reportRef }) => {
  const { t } = useTranslation();
  const trans_prefix = "admin_pages.attendance_reports";
  const trans = {
    title: t(`${trans_prefix}.card_titles.staff_all`),
    noRecords: t(`${trans_prefix}.card_titles.no_records`),
    date: t(`${trans_prefix}.filters.date`),
    requiredMsg: t("forms.required_field"),
    error: t("attendance.loadError"),
  };

  const tableColumns = [
    { key: "staff_name", label: t(`${trans_prefix}.staff_all_table_cols.staff_name`) },
    { key: "checking_time", label: t(`${trans_prefix}.staff_all_table_cols.checking_time`) },
    { key: "time_out", label: t(`${trans_prefix}.staff_all_table_cols.time_out`) },
  ];

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10)); // YYYY-MM-DD
  const [tableData, setTableData] = useState([]);
  const [loadingResult, setLoadingResult] = useState(false);
  const { school } = useContext(AuthContext);

  const axiosPrivate = useAxiosPrivate();

  const handleFilter = async () => {
    if (!date) {
      toast.error(trans.requiredMsg);
      return;
    }

    setLoadingResult(true);
    try {
      const url = API_URLS.getStaffAllAttendance(date, school.id);
      const response = await axiosPrivate.get(url);
      setTableData(response.data.attendance);
    } catch (err) {
      toast.error(trans.error);
    } finally {
      setLoadingResult(false);
    }
  };

  return (
    <div>
      <div className="d-flex gap-3 mb-4">
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="form-control w-25"
        />
        <Button onClick={handleFilter}>{t("buttons.filter")}</Button>
      </div>

      {loadingResult ? (
        <LoadingDots />
      ) : (
        <div ref={reportRef}>
          <h4>{trans.title}</h4>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {tableColumns.map((col) => (
                    <TableCell key={col.key}>{col.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={tableColumns.length}>{trans.noRecords}</TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      {tableColumns.map((col) => (
                        <TableCell key={col.key}>{row[col.key] || "-"}</TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
}